module.exports = {"level":{"Beginner":"Anfänger","Easy":"Leicht","Medium":"Mittel","Advanced":"Fortgeschritten"}};